import {Observer} from "../LibrariesImport";
import {GlobalVariables} from "../GlobalVariables";

export default class Header {
	constructor() {
		this.header = document.querySelector(".header-main");
		if (this.header) {
			this.navMain = this.header.querySelector(".navs");
			this.toggleHeader();
			this.resize();

		}
		GlobalVariables.resizeCallbacks.push(this);
	}

	getBreakpoint() {
		const rootStyle = getComputedStyle(document.documentElement);
		const breakpoint = rootStyle.getPropertyValue('--nav-breakpoint').trim();

		return parseInt(breakpoint);
	}

	toggleHeader() {
		Observer.create({
			type: "scroll",
			onChange: () => {
				this.header.classList.toggle("is-on-top", window.scrollY < 50);
			},
		});
	}

	resize() {
		if (window.innerWidth > this.getBreakpoint()) {
			document.body.classList.remove("navs-open");
			GlobalVariables.lenis?.start();
		}
	}
}
